import classNames from "classnames";
import styles from "./style.module.scss";
import SkeletonLoader from "shared/loaders/skeleton";
import { Icons } from "assets";

interface IStatsCard {
  count: any;
  icon: React.ReactNode;
  title: string;
  loading?: boolean;
}

const StatsCard = ({ count, icon, title, loading }: IStatsCard) => {
  return (
    <div className={classNames(styles.stats_item)}>
      <h2 className={classNames(styles.title)}>{title}</h2>
      <div className="flex justify-between items-start">
        {loading ? (
          <SkeletonLoader className={classNames(styles.loader)} />
        ) : (
          <h1 className={classNames(styles.count)}>{count ?? "0"}</h1>
        )}

        <span className={classNames(styles.iconContainer)}>{icon}</span>
      </div>
      {/* <div className={classNames(styles.linkContainer)}>
        <Icons.ArrowRight />
      </div> */}
    </div>
  );
};

export default StatsCard;
